<ul class="list archives">
  {{#archives}}
    <li>
      <span class="right btn-links sm">
        <a href="{{ download_path }}">Download <span class="flaticon stroke righted download-1"></span></a>
      </span>
      {{ title }}

      <small class="soft">{{ filename }}</small>
    </li>
  {{/archives}}
</ul>
